var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15953_2290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.86247 32.0062L11.6332 26.1315C11.9888 25.3774 13.0164 25.3774 13.372 26.1315L16.1427 32.0062L22.3388 32.9542C23.1338 33.0758 23.4506 34.0985 22.8751 34.6854L18.3925 39.255L19.4504 45.7107C19.5863 46.5398 18.7548 47.1718 18.0434 46.7803L12.5026 43.7307L6.96178 46.7803C6.25044 47.1718 5.41895 46.5398 5.55482 45.7107L6.61274 39.255L2.13007 34.6854C1.55452 34.0985 1.87138 33.0758 2.66636 32.9542L8.86247 32.0062Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8623 32.0062L43.6332 26.1315C43.9887 25.3774 45.0164 25.3774 45.3719 26.1315L48.1428 32.0062L54.3388 32.9542C55.1338 33.0758 55.4506 34.0985 54.8751 34.6854L50.3924 39.255L51.4503 45.7107C51.5863 46.5398 50.7548 47.1718 50.0434 46.7803L44.5026 43.7307L38.9618 46.7803C38.2503 47.1718 37.4188 46.5398 37.5548 45.7107L38.6127 39.255L34.13 34.6854C33.5546 34.0985 33.8714 33.0758 34.6663 32.9542L40.8623 32.0062Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8623 8.00631L27.6333 2.13154C27.9887 1.37738 29.0165 1.37738 29.3719 2.13154L32.1429 8.00631L38.3389 8.95418C39.1338 9.07578 39.4506 10.0986 38.8751 10.6853L34.3925 15.2549L35.4503 21.7107C35.5863 22.5398 34.7549 23.1718 34.0434 22.7803L28.5026 19.7307L22.9618 22.7803C22.2504 23.1718 21.4189 22.5398 21.5548 21.7107L22.6127 15.2549L18.1301 10.6853C17.5545 10.0986 17.8714 9.07578 18.6664 8.95418L24.8623 8.00631Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15953_2290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.232422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStars);
export default __webpack_public_path__ + "static/media/three-stars.c2abe4098626abeb99167bbaf1da408f.svg";
export { ForwardRef as ReactComponent };